module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 58.316 58.344",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#video-play",
      toString: function () {
        return this.url;
      }
    }